import { useFeatureAccessSettings } from '../featureAccessSettings';

type UseCanUserAccessLeadershipCorner = () => boolean;
export const useCanUserAccessLeadershipCorner: UseCanUserAccessLeadershipCorner = () => {
  const featureAccessSettings = useFeatureAccessSettings();

  return !!featureAccessSettings?.viewerCanAccessLeadershipCorner;
};
